import RangeWithNumerical from './RangeWithNumerical.container';
import {IRangeWithNumerical} from './RangeWithNumerical.interfaces';

export default RangeWithNumerical;
export { RangeWithNumerical, IRangeWithNumerical };
